import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';

export default class NgWords extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ngwords: [],
            lastPage: 1,
            currentPage: 1,
            removeDirectlyClick: 1,
            from: '',
            to: '',
            total: '',
        };
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePagination = this.handlePagination.bind(this);
    }
    
    /**
     * Init data and form ngwords or list ngwords
     */
    componentWillMount() {
        let keySearch_arr = {page: 1};
        //always get list data
        axios.get('/api/ngwords?'+ $.param(keySearch_arr)).then(response => {
            this.setState({
                ngwords: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: keySearch_arr,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
        });
        
    }
    
    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.get('/api/ngwords?'+ $.param(this.state.searchConditions)).then(response => {
            this.setState({
                ngwords: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }
    
    /**
     * handlePagination
     */
    handlePagination(key) {
        this.setState({
            searchConditions: key
        });
        axios.get('/api/ngwords?'+ $.param(this.state.searchConditions)).then(response => {
            this.setState({
                ngwords: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(this.state.searchConditions)
            });
        });
    }
    
    /**
     * Edit ngwords
     * client: Object NgWord
     */
    handleEdit(ngword) {
        this.props.history.push('/ngwords/edit/' + ngword.id);
    }
    
    /**
     * Delete ngword
     */
    handleDelete(ngWord) {
        if (window.confirm('このワードを削除してもよろしいですか？')) {
            axios.delete('api/ngwords/' + ngWord.id).then(response => {
                if (response.data.success) {
                    location.reload();
                }
            })
        }
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    render () {
        const columns = [
            {name: 'id', title: 'ID', isSort: 1, type: 'text'},
            {name: 'word', title: 'NGワード', isSort: 1, type: 'text'},
            {name: 'created_at', title: '追加日', isSort: 1, type: 'date'},
            {name: 'action', title: '操作', elements: ['edit', 'delete'], isSort: 0, type: 'action', edit_except_ids: [], delete_except_ids: []},
        ];
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">NGワード一覧</li>
                            </ol>
                        </nav>
                    </div>
		</div>

		<main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">NGワード一覧</h4>
                                        </div>
                                        <div className="col text-right">
                                            <a onClick={this.handleRedirect} href="/ngwords/create" className="btn btn-warning btn-space">NGワード新規登録</a>
                                        </div>
                                    </div>
                                </div>
                                <Table onSearch={this.handlePagination} data={this.state.ngwords} header={columns} onEdit={this.handleEdit} removeClick={this.state.removeDirectlyClick} onDelete={this.handleDelete}
                                    myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} onDetail={this.handleDetail} onSort={this.handleSort} from={this.state.from} to={this.state.to} total={this.state.total} />
                            </div>
                        </div>
                    </div>
		</main>
            </React.Fragment>
        );
    }
}
